export function initBottomNav() {
  var bottomNav = document.getElementById('mj-bottom-nav');
  var navToggle = document.getElementById('mj-bottom-nav-toggle');
  if (!bottomNav || !navToggle) return;

  var navState = sessionStorage.getItem('mj_nav_minimized');
  if (navState === 'false') {
    bottomNav.classList.remove('is-minimized');
  }

  setTimeout(function () { bottomNav.classList.add('is-ready'); }, 100);

  navToggle.addEventListener('click', function () {
    bottomNav.classList.toggle('is-minimized');
    sessionStorage.setItem(
      'mj_nav_minimized',
      bottomNav.classList.contains('is-minimized') ? 'true' : 'false'
    );
  });

  var vvTimer = null;
  var updateNavPosition = function () {
    if (!window.visualViewport) return;
    var offset = window.innerHeight - window.visualViewport.height;
    document.documentElement.style.setProperty('--vv-offset', Math.max(0, offset) + 'px');
  };
  var debouncedUpdate = function () {
    if (vvTimer) clearTimeout(vvTimer);
    vvTimer = setTimeout(function () {
      vvTimer = null;
      updateNavPosition();
    }, 200);
  };
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateNavPosition);
    window.visualViewport.addEventListener('scroll', debouncedUpdate, { passive: true });
    updateNavPosition();
  }
}
